import React from "react";

const IMPACT_METRICS = [
  {
    value: "3–5×",
    label: "Faster time to insight",
    color: "#05AB9A",
    bg: "#E6FBF5",
    icon: (
      <svg
        className="h-6 w-6"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#05AB9A"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 20V14" />
        <path d="M12 20V9" />
        <path d="M18 20V4" />
      </svg>
    ),
  },
  {
    value: "20–40%",
    label: "Higher productivity",
    color: "#7357FF",
    bg: "#F1EDFF",
    icon: (
      <svg
        className="h-6 w-6"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#7357FF"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
  },
  {
    value: "15–30%",
    label: "Cost reduction",
    color: "#3789EA",
    bg: "#EDF5FF",
    icon: (
      <svg
        className="h-6 w-6"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#3789EA"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    ),
  },
  {
    value: "25–50%",
    label: "Revenue uplift",
    color: "#FF880F",
    bg: "#FFF5E9",
    icon: (
      <svg
        className="h-6 w-6"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#FF880F"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <ellipse cx="12" cy="5" rx="9" ry="3" />
        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
      </svg>
    ),
  },
];

const RealImpactSection = () => {
  return (
    <section className="w-full border-b border-[#E2E8F0] bg-white py-8 sm:py-10">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-[70px]">
        {/* Subtitle Header */}
        <p className="mb-6 text-[11px] font-bold uppercase tracking-[2.6px] text-[#475569] sm:text-[12px]">
          REAL IMPACT. ACROSS INDUSTRIES.
        </p>

        {/* 4 Stats in Horizontal Flow */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:flex lg:items-center lg:justify-between lg:gap-0">
          {IMPACT_METRICS.map((item, idx) => (
            <React.Fragment key={item.label}>
              {/* Vertical divider line on desktop */}
              {idx > 0 && (
                <div className="hidden h-12 w-px bg-[#E2E8F0] lg:block" />
              )}

              {/* Metric Item */}
              <div className="flex items-center gap-4 lg:px-4 xl:px-6">
                {/* Circular Icon */}
                <div
                  className="flex h-[56px] w-[56px] shrink-0 items-center justify-center rounded-full transition-transform duration-300 hover:scale-105"
                  style={{ backgroundColor: item.bg }}
                >
                  {item.icon}
                </div>

                {/* Text Block */}
                <div className="flex flex-col">
                  <span className="text-[28px] font-bold leading-tight tracking-tight text-[#0F172A] sm:text-[32px] xl:text-[36px]">
                    {item.value}
                  </span>
                  <span className="text-[13px] font-medium leading-snug text-[#64748B] sm:text-[14px]">
                    {item.label}
                  </span>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RealImpactSection;
